import {loginTypeList} from "../../../shared/utils/enum";
import dayjs from "dayjs";
import {Sorter} from "../../../shared/components/Sorter";

export const getLoginLogColumns = (data = []) => {
    const udidFilters = [...new Set(data.map(row => row.udid).filter(Boolean))].map(udid => ({text: udid, value: udid}));
    return [
        {
            title: '로그인 타입',
            dataIndex: 'loginType',
            render: (loginType) => loginTypeList[loginType],
            filters: [
                {text: '게스트 로그인', value: 1},
                {text: '페이스북 로그인', value: 2},
                {text: '구글 로그인', value: 3},
                {text: '애플 로그인', value: 4},
            ]
        },
        {
            title: '플랫폼',
            dataIndex: 'platform',
            filters: [
                {text: 'iOS', value: 'IOS'},
                {text: 'Android', value: 'ANDROID'},
            ],
        },
        {
            title: 'OS',
            dataIndex: 'os',
        },
        {
            title: 'UDID',
            dataIndex: 'udid',
            filters: udidFilters,
        },
        {
            title: '디바이스',
            dataIndex: 'device',
        },
        {
            title: 'IP',
            dataIndex: 'ip',
        },
        {
            title: '날짜',
            dataIndex: 'created',
            render: (time) => dayjs.unix(time).format('YYYY-MM-DD HH:mm:ss'),
            sorter: (a, b) => Sorter.DATE(a.time, b.time),
        },
        {
            title: '국가',
            dataIndex: 'country',
        },
        {
            title: '버전',
            dataIndex: 'version'
        }
    ]
}